import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "px-side w-full h-full bg-light flex justify-end items-center"
}
const _hoisted_2 = { class: "text-bigger flex" }
const _hoisted_3 = { class: "ml-1 font-black lowercase" }
const _hoisted_4 = {
  key: 1,
  class: "w-full h-full bg-inprogress flex justify-center items-center text-sm"
}
const _hoisted_5 = { class: "uppercase" }

import { computed } from "vue";
import { useScheduleStore } from "@/store/Schedule";
import { useProfileStore } from "@/store/Profile";
import { formatTime } from "@/helpers/Time";
import i18n from "@/locale";

interface Props {
  isConnected: boolean;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    isConnected: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  isConnected: boolean;
}


const scheduleStore = useScheduleStore();
const profileStore = useProfileStore();
const dateOptions: Intl.DateTimeFormatOptions = { month: "long", day: "numeric" };

const formattedDate = computed(() => {
  return new Intl.DateTimeFormat(i18n.global.locale, dateOptions).format(scheduleStore.getTime);
});

const formattedTime = computed(() => {
  return formatTime(scheduleStore.getTime, profileStore.tabletTimeFormat);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "h-10 w-full",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('closeUpcoming')))
  }, [
    (props.isConnected)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(_unref(formattedDate)) + ",", 1),
            _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(formattedTime)), 1)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t("noInternetConnection")), 1)
        ]))
  ]))
}
}

})